import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

// Components
import { Heading2 } from "../../../../components/typography";
import { Body, Header, Button } from "../../../../components/UI";
import ManagerForm from "../ManagerForm/Manager.form";

// Icons
import { Close } from "../../../../SVGS";

// Form Models
import { ManagerFormModel } from "../../../../models/app/forms";

// Actions
import { updateManager } from "../../../../redux/actions/managers.actions";

// Builders
import * as buttonDesignType from "../../../../builders/buttonDesign.types";

// Services
import { managerValidation } from "../../../../services/validations/manager.validation";

// Styles
import { EditManagerStyles } from "./editManager.styles";

const EditManager = ({ closeModal }) => {
  const dispatch = useDispatch();
  const { chosenManager } = useSelector(state => state.managersPage);
  const initialValues = new ManagerFormModel(
    chosenManager.generateManagerForm()
  );

  const updateManagerHandler = values => {
    dispatch(updateManager(values, initialValues, chosenManager.id));
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: updateManagerHandler,
    validate: managerValidation
  });

  const {
    values,
    errors,
    touched,
    dirty,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    handleChange,
    handleBlur
  } = formik;

  return (
    <EditManagerStyles>
      <form autoComplete="new-password" onSubmit={handleSubmit}>
        <Header className="formHeader">
          <Heading2>EDIT MANAGER</Heading2>
          <div className="headerActions">
            {dirty && (
              <Button type="submit" buttonDesignType={buttonDesignType.PRIMARY}>
                Save Changes
              </Button>
            )}
            <Close onClick={closeModal} />
          </div>
        </Header>
        <Body>
          <ManagerForm
            values={values}
            errors={errors}
            touched={touched}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            handleBlur={handleBlur}
            handleChange={handleChange}
            hideButton
          />
        </Body>
      </form>
    </EditManagerStyles>
  );
};

export default EditManager;
